import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body pb-5" }
const _hoisted_2 = {
  id: "kt_customer_view_statement_tab_content",
  class: "tab-content"
}
const _hoisted_3 = {
  id: "kt_customer_view_statement_1",
  class: "py-0 tab-pane fade active show",
  role: "tabpanel"
}
const _hoisted_4 = {
  id: "kt_customer_view_statement_2",
  class: "py-0 tab-pane fade",
  role: "tabpanel"
}
const _hoisted_5 = {
  id: "kt_customer_view_statement_3",
  class: "py-0 tab-pane fade",
  role: "tabpanel"
}
const _hoisted_6 = {
  id: "kt_customer_view_statement_4",
  class: "py-0 tab-pane fade",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card ${_ctx.cardClasses}`)
  }, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("div", { class: "card-title" }, [
        _createElementVNode("h2", null, "Statement")
      ]),
      _createElementVNode("div", { class: "card-toolbar" }, [
        _createElementVNode("ul", {
          class: "nav nav-stretch fs-5 fw-bold nav-line-tabs nav-line-tabs-2x border-transparent",
          role: "tablist"
        }, [
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("a", {
              class: "nav-link text-active-primary active",
              "data-bs-toggle": "tab",
              role: "tab",
              href: "#kt_customer_view_statement_1"
            }, " This Year ")
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("a", {
              class: "nav-link text-active-primary ms-3",
              "data-bs-toggle": "tab",
              role: "tab",
              href: "#kt_customer_view_statement_2"
            }, " 2020 ")
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("a", {
              class: "nav-link text-active-primary ms-3",
              "data-bs-toggle": "tab",
              role: "tab",
              href: "#kt_customer_view_statement_3"
            }, " 2019 ")
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            role: "presentation"
          }, [
            _createElementVNode("a", {
              class: "nav-link text-active-primary ms-3",
              "data-bs-toggle": "tab",
              role: "tab",
              href: "#kt_customer_view_statement_4"
            }, " 2018 ")
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Datatable, {
            "table-header": _ctx.tableHeader,
            "table-data": _ctx.tableData1,
            "rows-per-page": 10,
            "enable-items-per-page-dropdown": false
          }, {
            "cell-date": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.date), 1)
            ]),
            "cell-order": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.order), 1)
            ]),
            "cell-details": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.details), 1)
            ]),
            "cell-amount": _withCtx(({ row: invoice }) => [
              _createElementVNode("span", {
                class: _normalizeClass(`text-${invoice.color}`)
              }, _toDisplayString(invoice.amount), 3)
            ]),
            "cell-invoice": _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("button", { class: "btn btn-sm btn-light btn-active-light-primary" }, " Download ", -1)
            ]))]),
            _: 1
          }, 8, ["table-header", "table-data"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Datatable, {
            "table-header": _ctx.tableHeader,
            "table-data": _ctx.tableData2,
            "rows-per-page": 10,
            "enable-items-per-page-dropdown": "false"
          }, {
            "cell-date": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.date), 1)
            ]),
            "cell-order": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.order), 1)
            ]),
            "cell-details": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.details), 1)
            ]),
            "cell-amount": _withCtx(({ row: invoice }) => [
              _createElementVNode("span", {
                class: _normalizeClass(`text-${invoice.color}`)
              }, _toDisplayString(invoice.amount), 3)
            ]),
            "cell-invoice": _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("button", { class: "btn btn-sm btn-light btn-active-light-primary" }, " Download ", -1)
            ]))]),
            _: 1
          }, 8, ["table-header", "table-data"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Datatable, {
            "table-header": _ctx.tableHeader,
            "table-data": _ctx.tableData3,
            "rows-per-page": 10,
            "enable-items-per-page-dropdown": false
          }, {
            "cell-date": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.date), 1)
            ]),
            "cell-order": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.order), 1)
            ]),
            "cell-details": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.details), 1)
            ]),
            "cell-amount": _withCtx(({ row: invoice }) => [
              _createElementVNode("span", {
                class: _normalizeClass(`text-${invoice.color}`)
              }, _toDisplayString(invoice.amount), 3)
            ]),
            "cell-invoice": _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("button", { class: "btn btn-sm btn-light btn-active-light-primary" }, " Download ", -1)
            ]))]),
            _: 1
          }, 8, ["table-header", "table-data"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Datatable, {
            "table-header": _ctx.tableHeader,
            "table-data": _ctx.tableData4,
            "rows-per-page": 10,
            "enable-items-per-page-dropdown": false
          }, {
            "cell-date": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.date), 1)
            ]),
            "cell-order": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.order), 1)
            ]),
            "cell-details": _withCtx(({ row: invoice }) => [
              _createTextVNode(_toDisplayString(invoice.details), 1)
            ]),
            "cell-amount": _withCtx(({ row: invoice }) => [
              _createElementVNode("span", {
                class: _normalizeClass(`text-${invoice.color}`)
              }, _toDisplayString(invoice.amount), 3)
            ]),
            "cell-invoice": _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("button", { class: "btn btn-sm btn-light btn-active-light-primary" }, " Download ", -1)
            ]))]),
            _: 1
          }, 8, ["table-header", "table-data"])
        ])
      ])
    ])
  ], 2))
}